<ng-container >
  <h1 class="form-title mt-4" translate>finance-data.bank</h1>
  <form class="finance-form" [formGroup]="institutionForm">
    <div>
      <kendo-formfield>
        <kendo-label class="form-label" text="{{'finance-data.bank.name' | translate}}" [infotooltip]="'finanzdaten.namedeskreditinstituts'" [for]="nameDesKreditInstituts" ></kendo-label>
        <kendo-textbox formControlName="nameDesKreditInstituts" [appinfotext]="'finanzdaten.namedeskreditinstituts'" #nameDesKreditInstituts
          preventEmptyFormatter [maxlength]=100>
        </kendo-textbox>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label class="form-label" text="{{'finance-data.bank.accountHolder' | translate}}"  [infotooltip]="'finanzdaten.kontoinhaber'" [for]="kontoinhaber"></kendo-label>
        <kendo-textbox formControlName="kontoinhaber" [appinfotext]="'finanzdaten.kontoinhaber'" #kontoinhaber
          preventEmptyFormatter [maxlength]=100>
        </kendo-textbox>
      </kendo-formfield>
    </div>
    <div>
      <kendo-formfield>
        <kendo-label class="form-label" text="{{'finance-data.bank.accountNumber' | translate}}"  [infotooltip]="'finanzdaten.iban'" [for]="iban"></kendo-label>
        <kendo-textbox formControlName="iban" [appinfotext]="'finanzdaten.iban'" preventEmptyFormatter [maxlength]=100 #iban>
        </kendo-textbox>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label class="form-label" text="{{'finance-data.bank.bic' | translate }}" [infotooltip]="'finanzdaten.bic'" [for] ="bic"></kendo-label>
        <kendo-textbox formControlName="bic" [appinfotext]="'finanzdaten.bic'" preventEmptyFormatter [maxlength]=100 #bic></kendo-textbox>
      </kendo-formfield>
    </div>
  </form>
</ng-container>